export default {
    loginDropdownTitle: ' ورود - ثبت نام ',
};
